export default "__VITE_ASSET__DbH4hwIJ__"